import { render, staticRenderFns } from "./assist-button.vue?vue&type=template&id=5e313ba5"
import script from "./assist-button.vue?vue&type=script&lang=ts"
export * from "./assist-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports